import { render, staticRenderFns } from "./CompTabela.vue?vue&type=template&id=0c93b80e&scoped=true&"
import script from "./CompTabela.vue?vue&type=script&lang=js&"
export * from "./CompTabela.vue?vue&type=script&lang=js&"
import style0 from "./CompTabela.vue?vue&type=style&index=0&id=0c93b80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c93b80e",
  null
  
)

export default component.exports